import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import getUrl from 'libraries/front-end-core/core/url'
import { PRECEDENTS_REVIEW, DOCUMENTS_REVIEW } from 'constants/controllers'
import Loading from 'components/shared/Loading'

export default new Controller({
  name: PRECEDENTS_REVIEW,
  route: '(:aol/)prereview/:category/:sectionId/:precedentIds',
  controller (
    Router,
    {
      scrollMain,
      url,
      query,
      params: { aol, category = null, sectionId = null, precedentIds = null }
    },
    render
  ) {
    const pageId = getUrl(PRECEDENTS_REVIEW, {
      aol,
      category,
      sectionId,
      precedentIds
    })

    // redirecting to documents
    replaceUrl(url.replace(PRECEDENTS_REVIEW, DOCUMENTS_REVIEW))

    render(
      { Main: Loading },
      {
        aol,
        category,
        sectionId,
        precedentIds: precedentIds.split(',')
      },
      {
        searchType: 'precedents',
        className: 'precedents',
        pageId,
        aol
      }
    )

    return pageId
  }
})
